export default [
  {
    path: '/ferramentas',
    component: () => import('@/components/template/MasterLayout'),
    children: [
      {
        path: 'assuntometro',
        component: () => import('@/components/pages/tools/AnswerToolPage'),
        name: 'tools.answer'
      },
      {
        path: 'instatags',
        component: () => import('@/components/pages/tools/InstaTagsToolPage'),
        name: 'tools.instatags'
      }
    ]
  }
]

